import {showError} from 'perform-base/js/flashes';

export default function () {
  var modal = $('.template-modal');
  var modalBody = $('.template-modal .modal-body');
  var modalSubmit = $('.insert-contract-template');
  var markdownBox = $('#contract_markdown');
  var inputTemplate = _.template($('#template-var-input').html());

  var setRequiredTemplateVars = function(vars) {
    modalBody.html('');
    _.each(vars, function(value, key) {
      modalBody.append(inputTemplate({
        name: key,
        label: value,
      }));
    });
  };

  var getTemplateVariables = function() {
    var data = {};
    modalBody.find('input').each(function() {
      data[$(this).attr('name')] = $(this).val().trim();
    });

    data.accountId = $('#contract_account').val();
    return data;
  };

  $('.contract-template').click(function(e) {
    e.preventDefault();
    if (markdownBox.val().trim() !== "") {
      showError('Make sure there is no existing text before inserting a template.');
      markdownBox.focus();
      return;
    }

    setRequiredTemplateVars($(this).data('vars'));

    var name = $(this).data('name');
    modal.modal('show');
    modalSubmit.data('name', name);
  });

  modalSubmit.click(function(e) {
    e.preventDefault();
    var url = '/contracts/template/'+modalSubmit.data('name');

    $.ajax({
      url: url,
      type: 'get',
      data: getTemplateVariables(),
      success: function (data) {
        markdownBox.val(data.markdown);
        markdownBox.focus();
      },
      error: function (data) {
        showError('An error occurred fetching this template.');
      },
      complete: function () {
        modal.modal('hide');
      }
    });
  });

  $('.preview-button').click(function(e) {
    e.preventDefault(); // prevents form submission
    if ($('.preview_box').is(":visible")) {
      $('.preview_box').hide()
      $('#contract_markdown').show();
      return;
    }
    var data = {
      'markdown': $('#contract_markdown').val(),
      'title': $('#contract_title').val(),
    };
    $.ajax({
        url: '/contracts/create/preview',
        type: 'POST',
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(response) {
          $('.preview_box').show();
          $('#contract_markdown').hide();
          
          $('.preview_box').html(response.html);
        },
    });
  });

  var updateRecipientType = function() {
    var isAccountContract = $('#contract_recipientType input:checked').val() === 'account';
    if (isAccountContract) {
      $('.optional-row-account').show();
      $('.optional-row-employee').hide();
      return;
    }
    $('.optional-row-employee').show();
    $('.optional-row-account').hide();
  }
  $('#contract_recipientType input').change(updateRecipientType);
  updateRecipientType();
};



// WEBPACK FOOTER //
// ./assets/js/contracts/write.js